import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { AxiosError } from 'axios';
import { UseQueryResult } from '@tanstack/react-query';

type UseNotFoundRedirectOptions<TData> = {
  queryResult: Pick<
    UseQueryResult<TData>,
    'data' | 'error' | 'isError' | 'isPending'
  >;
  checkResourceExists: (data: TData) => boolean;
};

export const useNotFoundRedirect = <TData>({
  queryResult,
  checkResourceExists,
}: UseNotFoundRedirectOptions<TData>) => {
  const navigate = useNavigate();
  const { data, error, isError, isPending } = queryResult;

  useEffect(() => {
    if (isPending) {
      return;
    }

    if (isError && error) {
      const axiosError = error as AxiosError;
      if (axiosError.response?.status === 404) {
        navigate('/not-found');
      }
    } else if (data && checkResourceExists) {
      if (!checkResourceExists(data)) {
        navigate('/not-found');
      }
    }
  }, [
    isError,
    error,
    data,
    navigate,
    isPending,
    checkResourceExists,
  ]);
};
